export default __webpack_public_path__ + "static/media/circle.f53d4ad8.usdz";